import React, { Component } from "react";
import "./Page2.css";

export default class Page2 extends Component {
  render() {
    return (
      <div className="Page2 Page">
        <div className="PageDetails">
          <div className="PageNum">1. </div>
          <h1>Concept</h1>
        </div>
        <div className="Text">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
        </div>
      </div>
    );
  }
}
